import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import BaseStep from "../../../../../../../shared/wizard/steps/baseStep";
import useGeoPolygonByBuilding from "../../../../../../../../api/hooks/use-geo-polygon-by-building";
import { TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../../..";

interface ISelectionByOwnSwapStep_3 {
  buildingId: number | null;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardBuy) => void;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnSwapStep_3 = ({
  buildingId,
  onChange,
  onReset,
}: ISelectionByOwnSwapStep_3) => {
  const { goToStep } = useWizard();

  const { trigger } = useGeoPolygonByBuilding();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_2);
    onReset(["desiredLocationIds"]);
  };

  const handleYestStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_4);
    onReset(["desiredLocationIds"]);
  };

  const handleNotStep = async () => {
    if (buildingId) {
      // по текущему билдингу с оценки получаем полигон
      const data = await trigger(buildingId);
      onChange([data.id], "desiredLocationIds");
    }
    goToStep(buySteps.selectionSteps.swap.step_5);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        yesStep={handleYestStep}
        noStep={handleNotStep}
        text={"Планируете сменить район проживания?"}
      />
    </div>
  );
};

export default SelectionByOwnSwapStep_3;
